import type { IconProps } from '../types/IconProps.ts';
export const SkipForward: IconProps = {
    name: 'SkipForward',
    children: [
        `<g clip-path="url(#a)">`,
        `<path d="M21 4v16M16.61 10.69a1.5 1.5 0 0 1 0 2.62L5.47 19.44a1.5 1.5 0 0 1-2.22-1.32V5.88a1.5 1.5 0 0 1 2.22-1.32z" />`,
        `</g>`,
        `<defs>`,
        `<clipPath id="a">`,
        `<path d="M0 0h24v24H0z" />`,
        `</clipPath>`,
        `</defs>`,
    ]
};